module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppSteppers', {
    attrs: {
      "start-step-name": "Данные пользователя"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var prevStep = ref.prevStep;
        var nextStep = ref.nextStep;

        return [_c('AppSteppersPane', {
          attrs: {
            "step-name": "Данные пользователя"
          }
        }, [_c('DynamicAdditionalDataForm', {
          attrs: {
            "next-step": nextStep
          }
        })], 1), _c('AppSteppersPane', {
          attrs: {
            "step-name": "Оформление заявки"
          }
        }, [_c('RequestForm', {
          attrs: {
            "next-step": nextStep
          },
          on: {
            "sendResult": function($event) {
              _vm.finishMsg = $event
            }
          }
        })], 1), _c('AppSteppersPane', {
          attrs: {
            "step-name": "Статус"
          }
        }, [_c('FinishMessage', {
          attrs: {
            "message": _vm.finishMsg,
            "close-modal": function () { return _vm.$ui.$modal.close("eventOrderProcess"); }
          }
        })], 1)]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71602cbe","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ordersProcessForms/event/EventOrderProcess.vue
// module id = 97aa30cd15dc664b8aa5
// module chunks = 5